import { Modal }              from '@widesk-ui/components/modal/Modal';
import { Action }             from '@widesk-ui/components/ButtonActions';
import { DeleteOutlined }     from '@ant-design/icons';
import confirmModelMessage    from '@widesk-ui/tools/actionModel/confirmModelMessage';
import ucFirst                from '@widesk-core/tools/ucFirst';
import { message }            from '@widesk-ui/hooks/useMessage';
import { WithLocalizedLabel } from '@widesk-core/mixins/ApiModelLocalizedLabel';
import { WithRenderName }     from '@widesk-ui/mixins/ApiModelRenderName';
import ApiModel               from '@widesk-core/models/ApiModel';

type DeleteModel = ApiModel & WithLocalizedLabel & WithRenderName;
type DeleteOptions<M extends DeleteModel> = {
	modelName?: string;
	before?: () => void;
	callback?: () => void;
	content?: string;
	success?: string;
	title?: string;
	hideModelName?: boolean;
	renderModelLabel?: (m: M) => string;
	actionProps?: Partial<Action>;
};

export const deleteModelConfirm = <M extends DeleteModel>(m: M, options: DeleteOptions<M> = {}) => {
	const label = options.renderModelLabel ? options.renderModelLabel(m) : m.modelLabel;
	const title = options.title
		|| confirmModelMessage(m, { hideModelName: options.hideModelName, modelLabel: label, modelName: options.modelName });

	return Modal.confirm({
		okText: [<DeleteOutlined />, 'Supprimer'],
		okType: 'danger',
		content: options.content,
		onOk: async () => {
			try {
				if (options.before) {
					await options.before();
				}

				await m.destroy();

				if (options.callback) {
					options.callback();
				}

				const success = options.success
					|| ucFirst(`L'élément ${options?.hideModelName ? '' : `${m.localize()} `}"${label}" a bien été supprimé.`);

				message.success(success);
			} catch (err) {
				message.exception(err);
			}
		},
		title,
	});
};

const actionDeleteModel = <M extends DeleteModel>(
	model: M,
	options?: DeleteOptions<M>,
) => {
	return {
		danger: true,
		icon: <DeleteOutlined />,
		label: options?.title || `Supprimer` + (options?.hideModelName ? '' : ` - ${options?.modelName || model.localize()}`),
		onClick: async () => deleteModelConfirm(model, options),

		...options?.actionProps,
	};
};

export default actionDeleteModel;
